import gql from 'graphql-tag';


export const add = gql`mutation CreateCompany($company: CompanyInput!) {
    createCompany(company: $company) {
        id
        name
        isUnderwriter
        rebateRate
        address
        country {
            id
            name
            isoCode
        }
    }
}`;

export const edit = gql`mutation EditCompany($id: ID!, $company: CompanyInput!) {
    editCompany(id: $id, company: $company) {
        id
        name
        isUnderwriter
        rebateRate
        address
        country {
            id
            name
            isoCode
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/company.js